import React, { useState, useEffect } from 'react';
import './styles.css';

const SpinningModal = () => {
    // Corrected image paths
    const figCropLogo = '/src/assets/fig_CROP.png'; // Front side
    const swanLogo = '/src/assets/swanailogo.png'; // Placeholder alternate logo (can be changed later)
    const figAgentLogo = '/src/assets/fig_agent.png'; // Back side

    const [frontImage, setFrontImage] = useState(figCropLogo); // Initialize with fig_CROP logo

    // Switch between fig_CROP and SwanAI logos every 3 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setFrontImage((prevImage) => (prevImage === figCropLogo ? swanLogo : figCropLogo));
        }, 3000); // Switch every 3 seconds

        return () => clearInterval(interval);
    }, [figCropLogo, swanLogo]);

    return (
        <div className="spinning-modal">
            <div className="spinning-logo">
                {/* Front side: alternating between fig_CROP and SwanAI logos */}
                <img
                    src={frontImage}
                    alt="Front Logo"
                    className="logo-front"
                    onError={(e) => (e.target.src = '/src/assets/default-placeholder.png')} // Fallback image
                />
                {/* Back side: fig_agent.png */}
                <img
                    src={figAgentLogo}
                    alt="Back Logo"
                    className="logo-back"
                    onError={(e) => (e.target.src = '/src/assets/default-placeholder.png')} // Fallback image
                />
            </div>
        </div>
    );
};

export default SpinningModal;
